import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class HaleroveVyrovnaniProvider extends BaseApi {
	async saveTable(table: any) {
		return this.update(`/${DMS_MODULE}/${NAME}`, table);
	}
}

export const apiProvider = new HaleroveVyrovnaniProvider(DMS_MODULE, NAME);
